<template>
        <div class="mb-primary">
            <app-tab :tabs="tabsSuppliers" :active-tab="activeTab" type="horizontal"  :selectedUrl="selectedUrl"/>
        
        </div>
</template>

<script>

export default {
    props: {
        companyType: {
            type: Number,
            required: false
        }
    },
    data() {
        return {
            icon: 'settings',
            selectedUrl: '',
            tabsSuppliers: [
                {
                    "icon": "send",
                    "name": "suppliers information",
                    "component": "supplier-add",
                    "permission": "",
                    "disabled": false,
                    "queryParam": "suppliers+information", // El valor para el query param del tab


                },
                {
                    "icon": "phone",
                    "name": "Contacts",
                    "component": "supplier-contacts",
                    "permission": "",
                    "disabled": true,
                    "queryParam": "Contacts", // El valor para el query param del tab

                },
                {
                    "icon": "send",
                    "name": "Addresses",
                    "component": "supplier-Address",
                    "permission": "",
                    "disabled": true,
                    "queryParam": "Addresses", // El valor para el query param del tab

                },
            ],
            activeTab: 0
        }
    },

    created(){
        // esta llegando el 2 pero no lo usare ahoramismo
    },

}
</script>